<app-forecast-information #summary></app-forecast-information>

<main class="container" style="min-height:700px !important;">
    <section class="row pt-3">
        <div class="col-12 d-flex text-white justify-content-center">
            <h4>Forecast Año {{year}} en {{typeMoney}}</h4>
        </div>
        <div class="col-12 p-2" >
            <div class="">
                <div class="chart-container p-3" style="position: relative;">
                  <canvas id="chart-line" ></canvas>
                </div>
        </div>
        </div>


        <div class="mt-3 text-white">
          <div class="">
              <form   class="needs-validation2 row mx-5"
          action=""
          method="get"
          [formGroup]="formSearch"
        > 

          <div class="col-2  d-flex flex-column mt-2">
            <label for="sucursal" class="form-label text-color">Año </label>
            <select class="mx-1 custom-outline-input form-select w-auto " aria-label="Default select" formControlName="optionTypeYear">
              <option value="0">Año</option>
              <option value="{{option.id}}" *ngFor="let option of listYear">
              {{option.name}}
              </option>
          </select>
          </div>


          <div class="col-2  d-flex flex-column mt-2">
            <label for="sucursal" class="form-label text-color">Tipo de pago </label>

            <select class="mx-1 custom-outline-input form-select w-auto " aria-label="Default select" formControlName="optionTypePay">
              <option value="0">Tipo de pago</option>
              <option value="{{option.id}}" *ngFor="let option of listPlayOption">
              {{option.name}}
              </option>
          </select>
          </div>

          <div class="col-2  d-flex flex-column mt-2">
            <label for="sucursal" class="form-label text-color">Estado </label>
            <select class="mx-1 custom-outline-input form-select w-auto" aria-label="Default select" formControlName="optionState">
                    <option value=""> Estados</option>
                    <option > Pago </option>
                    <option > Pendiente </option>
                    <option > Vencido </option>
                    <option > Descuento </option>
                </select>
          </div>

          <div class="col-2  d-flex flex-column mt-2">
            <label for="sucursal" class="form-label text-color">Cliente </label>
            <select  class="mx-1 custom-outline-input form-select w-auto" aria-label="Default select" formControlName="optionClient">
              <option value="0">Cliente</option>
              <option value="{{option.id}}" *ngFor="let option of listFilterClient">
              {{option.name}}
              </option>
          </select>
          </div>

          <div class="col-2  d-flex flex-column mt-2">
            <label for="sucursal" class="form-label text-color">Pais Operación</label>
            <ng-multiselect-dropdown id="stado"  formControlName="selectOperation" class="flex-grow-1"
            [placeholder]="'Pais Operación'"
            [settings]="dropdownSettings"
            [data]="filterOperation">
          </ng-multiselect-dropdown>
          </div>

          <div class="col-2  d-flex flex-column mt-2">
            <label for="sucursal" class="form-label text-color">Pais Venta Comercial </label>
            <ng-multiselect-dropdown id="stado" formControlName="selectComercialOrigen" class="flex-grow-1"
            [placeholder]="'Pais Venta Comercial'"
            [settings]="dropdownSettings"
            [data]="filterComercialOrigen">
           >
          </ng-multiselect-dropdown>
          </div>
<!-- 
          <div class="col-2  d-flex flex-column  mt-2">
            <label for="sucursal" class="form-label text-color">Tipo de servicio </label>
            <select class="mx-1 custom-outline-input form-select flex-grow-1" aria-label="Default select" formControlName="optionTypeService">
                <option value="">Tipo de servicio</option>
                <option value="{{option.id}}" *ngFor="let option of listTypeService">
                {{option.name}}
                </option>
            </select>
          </div> -->

          <div class="col-2  d-flex flex-column  mt-2">
            <label for="sucursal" class="form-label text-color">Conversor de moneda</label>
            <select class="mx-1 custom-outline-input form-select flex-grow-1" aria-label="Default select" formControlName="currencyTransf">
                <option value="0">Tipo de pago</option>
                <option value="{{option.id}}" *ngFor="let option of listPlayOption">
                {{option.name}}
                </option>
            </select>
          </div>


          <div class="col-8 d-flex justify-content-end bd-highlight ">
            <div class="col-2 me-1 align-self-end bd-highlight">
                <div class="d-flex justify-content-center align-items-center">
                    <button (click)="formSubmit()" type="submit"  class="btn btn-outline-light flex-grow-1">Buscar</button>
                </div>
            </div>


            <div class="col-3 me-1 align-self-end bd-highlight">
              <div class="d-flex justify-content-center align-items-center">
                  <button (click)="download('0')" class="btn btn-outline-light flex-grow-1 "><i class="fa-solid fa-file-excel mx-1"></i> Descargar Excel</button>
              </div>
          </div>


          <div class="col-2 me-1 align-self-end bd-highlight">
              <div class="d-flex justify-content-center align-items-center">
                  <button (click)="limpButton()" class="btn btn-outline-light flex-grow-1 ">Limpiar</button>  
              </div>
          </div>


    </div>
 
              </form>
          </div>
        </div>



        <div class="container-fluid px-5 pt-5">
            <div class="backgroundTable">
        
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="componente-importantes componente-importantes-from-popup">

                <ng-container *ngIf="listOption.length == 0">">
                  <div class="text-center text-white">
                    <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                    <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                  </div>
                </ng-container>
      
                <ng-container *ngIf="listOption.length != 0">
                <thead>
                  <tr>
                    <th class="text-white text-center">Mes</th>
                    <th class="text-white text-center">Año</th>
                    <th class="text-white text-center">Backlog</th>
                    <th class="text-white text-center">Cierre Ventas (Nuevo + Ext)</th>
                    <th class="text-white text-center">Ver Mas</th>
                    <th class="text-white text-center">Exportar</th>
                </thead>
      
                <tbody>
                  <tr *ngFor="let item of listOption">

                    <td class="text-center" >{{item.month}}</td>
                    <td class="text-center" >{{item.yearToday}}</td>
                    <td class="text-center" >{{item.payPast}}</td>
                    <td class="text-center" >{{item.payToday}}</td>
                    <td class="text-center">
                          <div class="col-auto"><span class="pointer " (click)="summary.open(item)"> <i class="fa-solid fa-eye fa-xl pointer"></i></span></div>
                    </td>
                    <td class="text-center">
                          <div class="col-auto"><span class="pointer " (click)="download(item.monthNumber)" > <i class="fa-solid fa-file-excel fa-xl pointer"></i></span></div>
                    </td>

                  </tbody>
                </ng-container>
                  </table>
      
                </div>
              </div>



    </section>
</main>